import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TenantLookupFormComponent } from '../../components/tenant-lookup-form/tenant-lookup-form.component';

@Component({
  selector: 'app-tenant-entry',
  imports: [TenantLookupFormComponent],
  templateUrl: './tenant-entry.component.html',
  styleUrl: './tenant-entry.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TenantEntryComponent {
  private readonly router = inject(Router);

  protected onLookupSuccess(tenantName: string): void {
    // Success! Reload page with tenant in URL
    // This will trigger APP_BASE_HREF to be set correctly
    window.location.href = `/${tenantName}/`;
  }

  protected onLookupError(tenantName: string): void {
    // Navigate to organization-not-found page with attempted name
    this.router.navigate(['/organization-not-found'], {
      queryParams: { attemptedName: tenantName },
    });
  }
}
